exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.headline-box[data-v-2f90afa0] {\n  padding: 0.2667rem 0;\n}\n.headline-box .headline-t-s[data-v-2f90afa0] {\n  padding: 0 0.4rem /* 30/75 */;\n}\n.headline-box .headline-searchel[data-v-2f90afa0] {\n  margin: 0.2667rem /* 20/75 */ 0;\n}\n", ""]);

// exports
